import {
  CellClickedEvent,
  CellDoubleClickedEvent,
  ColDef,
  ColumnMovedEvent,
  ColumnResizedEvent,
  GetRowIdFunc,
  GetRowIdParams,
  IRowNode,
  RowDragEndEvent,
  RowDragMoveEvent,
  RowHeightParams,
  SuppressKeyboardEventParams,
} from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  CUSTOM_COLUMN_KEY,
  LEASE_STATUS,
  NONE_MENU_ID,
  REMINDER_IN_1_WEEK_OR_MORE,
  REMINDER_IN_2_DAYS,
  REMINDER_IN_3_DAYS,
  REMINDER_IN_4_DAYS,
  REMINDER_IN_5_DAYS,
  REMINDER_IN_6_DAYS,
  REMINDER_PAST_DUE,
  REMINDER_TODAY,
  REMINDER_TOMORROW,
  REMINDER_TREE_ROOT_NODES,
  SETTINGS_TYPE,
  SIDE_BAR_TREE,
} from "../../../common/constants";
import { CustomDashboardParams } from "../../../common/types/dashboard/DashboardUITypes";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

import _, { after } from "lodash";
import {
  DocumentEntity,
  DocumentFieldValuesEntity,
  FieldEntity,
} from "../../../common/types/EntityTypes";
import { updateDocumentReadStatus } from "../../../db/documentDBAction";
import {
  fetchDocumentHTML,
  rowCollapseUpdate,
  rowExpandUpdate,
  selectCurrentTab,
  selectIsDocumentDeleted,
  selectNewParentToExpand,
  selectPivotSelectedText,
  selectPrevDocumentExpandedId,
  selectSelectedDocumentExpandedId,
  selectSelectedDocumentId,
  selectSideBarLevelToDocIds,
  selectSideBarNodeSelected,
  selectSideBarSelectedTree,
  selectUserStatusFilterEnabled,
  setDocumentDeleted,
  setDocumentExpanded,
  setSelectedDocument,
  updateFieldResize,
  updateRowReadStatus,
} from "../../../redux/reducers/dashboardSlice";
import {
  dragLeaseMapping,
  markDocumentRead,
  selectRows,
  setDocumentRowAsExpanded,
  unGroupLeaseDoc,
  // checkAndRemoveParentFromDocuments
} from "../../../redux/reducers/documentsDataSlice";
import { checkAndRemoveParentFromDocuments } from "../../../redux/action";
import { selectLeaseStatus } from "../../../redux/reducers/leaseStatusSlice";
import {
  selectFields,
  selectInboxId,
  updateColumnOrder,
  updateFieldOrder,
} from "../../../redux/reducers/metadataSlice";
import {
  selectShow,
  setAbstraction,
  setFieldToBeSelectedInEdit,
  setMenu,
} from "../../../redux/reducers/popupSlice";
import {
  selectCurrentHeight,
  selectFontPer,
  selectResolutionMetadata,
  selectTableFontSize,
  selectCustomActiveRowHeight,
  selectCustomInActiveRowHeight,
  selectCustomCellPadding,
  selectCustomLineHeight,
} from "../../../redux/reducers/uiSlice";
import "./Table.scss";
import TableCell from "./table-cell/TableCell";
import TableHeader from "./table-header/TableHeader";
import { updateDocumentStatusForReadStatus } from "../../../redux/reducers/documentsStatusSlice";
import {
  getUpdatedCustomFontSize,
  mergeWithStrictPrecedence,
} from "../../../common/util";
import {
  selectedRelatedUnmatchedDocs,
  selectParentsWithChildren,
  selectRelatedUnmatchedDocuments,
  setParentsWithChildren,
  setRelatedUnmatchedDocIds,
  setRelatedUnmatchedDocuments,
  updateParentsWithChildren,
} from "../../../redux/reducers/documentsSlice";
import {
  selectDefaultSettingsForSettings,
  selectEnabledSettingsFilterViewMetadata,
  selectUserAutoFilterSettings,
  selectUserTableFontSize,
} from "../../../redux/reducers/settingsSlice";
import classNames from "classnames";
import {
  getFilterListForDocument,
  selectSelectedTabFilterInfo,
} from "../../../redux/reducers/tabFilterSlice";
import { selectReadOnlyApp } from "../../../redux/reducers/appSlice";
import { param } from "jquery";
import { normalizeText } from "./table-util";
import states from "../../dialog/edit/editable-value/states-constants";
import moment from "moment";

// Images import

function Table(props: CustomDashboardParams) {
  const gridRef = useRef<AgGridReact<DocumentEntity>>(null);
  const uiTableFontSize = useAppSelector(selectTableFontSize);
  const selectedTabFilter = useAppSelector(selectSelectedTabFilterInfo);
  const selectedPivotValue = useAppSelector(selectPivotSelectedText);
  const selectedSideBarTree = useAppSelector(selectSideBarSelectedTree);
  const selectReminderParentNode = useAppSelector(selectSideBarNodeSelected);
  const sideBarLevelToDocIds = useAppSelector(selectSideBarLevelToDocIds);
  const isReadOnly = useAppSelector(selectReadOnlyApp);
  //Font change Per
  const fontChangePer = useAppSelector(selectFontPer);
  const resMetadata = useAppSelector(selectResolutionMetadata);
  const userActiveRowHeight = Number(
    useAppSelector(selectCustomActiveRowHeight)
  );
  const userInActiveRowHeight = Number(
    useAppSelector(selectCustomInActiveRowHeight)
  );
  const userCellPadding = Number(useAppSelector(selectCustomCellPadding));
  const userLineHeight = Number(useAppSelector(selectCustomLineHeight));
  const userTableFontSize = Number(
    useAppSelector(selectUserTableFontSize).value
  );
  const currentScreenHeight = useAppSelector(selectCurrentHeight);

  const userActiveLine = useAppSelector(selectCustomActiveRowHeight);
  const userInActiveLine = useAppSelector(selectCustomInActiveRowHeight);

  // Selected Tab
  const selectedTab = useAppSelector(selectCurrentTab);
  const inboxTabId = useAppSelector(selectInboxId);
  const inboxDocuments = useAppSelector(selectRows)[inboxTabId];
  const isDocumentDeleted = useAppSelector(selectIsDocumentDeleted);
  const isLeaseFilterStatusActive = useAppSelector(
    selectUserStatusFilterEnabled
  );
  // Headers Selection
  const headers = useAppSelector(selectFields);
  const isUploadPopupOpen = useAppSelector(selectShow);
  // Rows App Selector
  const rows = useAppSelector(selectRows);
  const selectedDocumentId = useAppSelector(selectSelectedDocumentId);
  // Children For Current Selected Row
  const expandedParent = useAppSelector(selectSelectedDocumentExpandedId);
  const prevExpandedParent = useAppSelector(selectPrevDocumentExpandedId);
  const parentsWithChildren = useAppSelector(selectParentsWithChildren);
  const newParentToExpand = useAppSelector(selectNewParentToExpand);

  // Children master details
  const leaseStatusFilters = useAppSelector(selectLeaseStatus);
  const dispatch = useAppDispatch();

  // Shadow ref
  const beforeShadowRef = useRef("");
  const afterShadowRef = useRef("");

  const customStyle = {
    width: "100%",
    height:
      currentScreenHeight < 900 ? "calc(100% - 32px)" : "calc(100% - 52px)",
    "--custom-font-size": uiTableFontSize + "px",
    "--custom-line-height": userLineHeight,
    "--custom-cell-padding": userCellPadding + "px",
    "--custom-dashboard-author-font-size": getUpdatedCustomFontSize(
      "--custom-dashboard-author-font-size"
    ),
  };

  const [clickTimeout, setClickTimeout] = useState<NodeJS.Timeout | null>(null);
  const [expandTo10Rows, setExpandTo10Rows] = useState<Boolean | null>(false);
  const [lastExpandStatus, setLastExpandStatus] = useState<Boolean | null>(
    null
  );

  const findExpandedDocument = () => {
    let expandedId = "";

    for (const key in rows) {
      if (rows.hasOwnProperty(key)) {
        const doc = rows[key].find((item) => item.expanded);
        if (doc) {
          expandedId = doc.id;
          dispatch(setDocumentExpanded(expandedId));
        }
      }
    }
  };

  const getRowHeight = useCallback(
    (params: RowHeightParams) => {
      if (params.data.locked) {
        return (
          userActiveLine * userTableFontSize * userLineHeight +
          userCellPadding * 2
        );
      }
      return (
        userInActiveLine * userTableFontSize * userLineHeight +
        userCellPadding * 2
      );
    },
    [fontChangePer]
  );
  //  Expanding row height for one always
  useEffect(() => {
    if (
      (!_.isEmpty(rows) && isDocumentDeleted) ||
      selectedDocumentId === undefined
    ) {
      gridRef.current?.api?.forEachNode(function (rowNode) {
        if (rowNode.data?.id === transformedRowsData[0].id) {
          rowNode.setRowHeight(
            (expandTo10Rows && rowNode.data?.id === selectedDocumentId
              ? userActiveLine
              : userInActiveLine) *
              userTableFontSize *
              userLineHeight +
              userCellPadding * 2
          );
          rowNode.setSelected(true);
          gridRef.current?.api.onRowHeightChanged();
          dispatch(setSelectedDocument(rowNode.data));
          dispatch(setDocumentDeleted(false));
        }
        if (
          !rowNode.data?.locked &&
          !rowNode.isSelected() &&
          userInActiveRowHeight > 0
        ) {
          rowNode.setRowHeight(
            (expandTo10Rows && rowNode.data?.id === selectedDocumentId
              ? userActiveLine
              : userInActiveLine) *
              uiTableFontSize *
              userLineHeight +
              userCellPadding * 2
          );
        }
      });
    }
  }, [isDocumentDeleted, rows, expandTo10Rows]);

  // Resizing Row Height
  useEffect(() => {
    gridRef?.current?.api?.forEachNode(function (rowNode) {
      if (
        !rowNode.data?.locked &&
        !rowNode.isSelected() &&
        userInActiveRowHeight > 0
      ) {
        rowNode.setRowHeight(
          (expandTo10Rows && rowNode.data?.id === selectedDocumentId
            ? userActiveLine
            : userInActiveLine) *
            uiTableFontSize *
            userLineHeight +
            userCellPadding * 2
        );
      } else if (
        rowNode.data?.locked ||
        (rowNode.isSelected() && userActiveRowHeight > 0)
      ) {
        rowNode.setRowHeight(
          (expandTo10Rows && rowNode.data?.id === selectedDocumentId
            ? userActiveLine
            : userInActiveLine) *
            uiTableFontSize *
            userLineHeight +
            userCellPadding * 2
        );
      }
    });
    const headerLines = uiTableFontSize > 18 ? 2.75 : 2;
    gridRef?.current?.api?.setHeaderHeight(
      headerLines * uiTableFontSize * userLineHeight + userCellPadding * 1.25
    );
    gridRef?.current?.api?.onRowHeightChanged();
  }, [
    userInActiveRowHeight,
    userActiveRowHeight,
    userCellPadding,
    uiTableFontSize,
    rows,
    expandTo10Rows,
  ]);

  useEffect(() => {
    regulateParentChildShadow();
  }, [rows, selectedTab, expandedParent, parentsWithChildren]);

  useEffect(() => {
    if (newParentToExpand != "" && expandedParent !== newParentToExpand) {
      handleRowExpandCollapse(newParentToExpand);
    }
  }, [newParentToExpand]);

  const getColumnWidth = (headerKey: String) => {
    switch (headerKey) {
      case CUSTOM_COLUMN_KEY.PIN:
        return resMetadata.columns_dimension.PIN.widthPX;
      case CUSTOM_COLUMN_KEY.AUTHOR:
        return resMetadata.columns_dimension.AUTHOR.widthPX;
      case CUSTOM_COLUMN_KEY.STATUS:
        return resMetadata.columns_dimension.STATUS.widthPX;
      case CUSTOM_COLUMN_KEY.MARKET:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.LOI_DATE_KEY:
        return resMetadata.columns_dimension.LOI_DATE.widthPX;
      case CUSTOM_COLUMN_KEY.STATE:
        return resMetadata.columns_dimension.STATE.widthPX;
      case CUSTOM_COLUMN_KEY.CITY:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.TRADE_AREA:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.TENANT_ENTITY:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.TENANT:
        return resMetadata.columns_dimension.MARKET.widthPX + 1;
      case CUSTOM_COLUMN_KEY.TENANT_OWNER:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.GUARANTOR:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.GUARANTOR_COMPANY:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.LANDLORD_ENTITY:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.PROJECT:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.ADDRESS:
        return resMetadata.columns_dimension.MARKET.widthPX + 20;
      case CUSTOM_COLUMN_KEY.SUITE:
        return resMetadata.columns_dimension.SUITE.widthPX;
      case CUSTOM_COLUMN_KEY.SIZE:
        return resMetadata.columns_dimension.SUITE.widthPX;
      case CUSTOM_COLUMN_KEY.BASE_RENT:
        return resMetadata.columns_dimension.SUITE.widthPX;
      case CUSTOM_COLUMN_KEY.TIA:
        return resMetadata.columns_dimension.SUITE.widthPX;
      case CUSTOM_COLUMN_KEY.OPTIONS:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.TERM:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.NNNN_ESTIMATE:
        return resMetadata.columns_dimension.STATE.widthPX;
      case CUSTOM_COLUMN_KEY.RET:
        return resMetadata.columns_dimension.SUITE.widthPX;
      case CUSTOM_COLUMN_KEY.CAM:
        return resMetadata.columns_dimension.CAM.widthPX;
      case CUSTOM_COLUMN_KEY.UNCONTROLLED_CAM:
        return resMetadata.columns_dimension.CAM.widthPX;
      case CUSTOM_COLUMN_KEY.CONTROLLED_CAM:
        return resMetadata.columns_dimension.CAM.widthPX;
      case CUSTOM_COLUMN_KEY.FIXED_CAM:
        return resMetadata.columns_dimension.CAM.widthPX;
      case CUSTOM_COLUMN_KEY.VARIABLE_CAM:
        return resMetadata.columns_dimension.CAM.widthPX;
      case CUSTOM_COLUMN_KEY.INS:
        return resMetadata.columns_dimension.SUITE.widthPX;
      case CUSTOM_COLUMN_KEY.DELIVERY_DATE:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.RENT_ABATEMENT:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.PERCENTAGE_RENT:
        return resMetadata.columns_dimension.MARKET.widthPX;
      case CUSTOM_COLUMN_KEY.NOTES:
        return resMetadata.columns_dimension.NOTES.widthPX;
      case CUSTOM_COLUMN_KEY.NOTES_HIDDEN:
        return resMetadata.columns_dimension.NOTES_HIDDEN.widthPX;
      case CUSTOM_COLUMN_KEY.STATUS_HIDDEN:
        return resMetadata.columns_dimension.STATUS_HIDDEN.widthPX;
      case CUSTOM_COLUMN_KEY.CHILDREN:
        return resMetadata.columns_dimension.CHILDREN.widthPX;
      case CUSTOM_COLUMN_KEY.DOCUMENT_NAME:
        return resMetadata.columns_dimension.DOC_NAME.widthPX;
      case CUSTOM_COLUMN_KEY.DOCUMENT_HIDDEN:
        return resMetadata.columns_dimension.DOCUMENT_HIDDEN.widthPX;
      case CUSTOM_COLUMN_KEY.REMINDER:
        return resMetadata.columns_dimension.REMINDER.widthPX;
      case CUSTOM_COLUMN_KEY.REMINDER_HIDDEN:
        return resMetadata.columns_dimension.REMINDER_HIDDEN.widthPX;
      default:
        return resMetadata.columns_dimension.OTHERS.widthPX;
    }
  };

  const userAutoSettings = useAppSelector(selectUserAutoFilterSettings);
  const defaultAutoSettings =
    useAppSelector((state) =>
      selectDefaultSettingsForSettings(state, SETTINGS_TYPE.AUTO_FILTERED_LOIS)
    ) || [];
  const settingMetadata = useAppSelector(
    selectEnabledSettingsFilterViewMetadata
  );
  const sideBarSelectedTree = useAppSelector(selectSideBarSelectedTree);
  let selectedAutoSettings: string[] = [];

  useMemo(() => {
    const mergedAutoSettings = mergeWithStrictPrecedence(
      defaultAutoSettings,
      userAutoSettings
    );
    const selectedTreeSettingsId = settingMetadata.find(
      (s) => s.name.toLowerCase() === sideBarSelectedTree.toLowerCase()
    )?.externalId;

    selectedAutoSettings = mergedAutoSettings
      .filter(
        (s) =>
          s.subSettingsExternalId === selectedTreeSettingsId &&
          s.name !== "minimum_loi"
      )
      .map((s) => s.value);
  }, [
    sideBarSelectedTree,
    userAutoSettings,
    defaultAutoSettings,
    settingMetadata,
    selectedPivotValue,
  ]);

  const transformedHeadersDef = useMemo(() => {
    if (headers.length > 0) return transformHeaders(headers);
  }, [headers, selectedDocumentId]);

  const transformedRowsData = useMemo(() => {
    // const clientsWithData = Object.keys(rows);
    // const dummyRowsFromIndex = localStorage.getItem(CLIENT_DUMMY_ROW_IDS);
    let data: DocumentEntity[] = [];
    if (selectedTab != undefined && !_.isEmpty(rows)) {
      if (selectedTab in rows) {
        if (inboxTabId !== selectedTab || isReadOnly) {
          let relatedDocuments: any = [];
          if (rows[selectedTab]?.length > 0) {
            const lookedUpIds = new Set(rows[selectedTab].map((doc) => doc.id)); // Track IDs in selectedTab and added documents
            rows[selectedTab].forEach((anchorDoc) => {
              const relatedFilteredDocs =
                rows[inboxTabId]?.filter((inboxDoc) => {
                  // Skip if inboxDoc ID is already seen (in selectedTab or already added)
                  if (lookedUpIds.has(inboxDoc.id)) {
                    return false;
                  }

                  // Case 1: Get children of anchorDoc
                  if (anchorDoc.id === inboxDoc.parent) {
                    lookedUpIds.add(inboxDoc.id); // Mark ID as seen
                    return true;
                  }

                  // Case 2: Get parent and siblings of anchorDoc
                  if (
                    anchorDoc.parent !== "" &&
                    (inboxDoc.parent === anchorDoc.parent ||
                      inboxDoc.id === anchorDoc.parent)
                  ) {
                    lookedUpIds.add(inboxDoc.id); // Mark ID as seen
                    return true;
                  }

                  return false;
                }) || []; // Fallback to empty array if rows[inboxTabId] is undefined

              relatedDocuments.push(...relatedFilteredDocs);
            });
            const selectedTabIds = new Set(
              rows[selectedTab].map((doc) => doc.id)
            );
            const uniqueRelatedDocuments = relatedDocuments.filter(
              (doc: DocumentEntity) => !selectedTabIds.has(doc.id)
            );
            dispatch(
              setRelatedUnmatchedDocIds(_.map(uniqueRelatedDocuments, "id"))
            );
            dispatch(setRelatedUnmatchedDocuments(uniqueRelatedDocuments));
            data = [...rows[selectedTab], ...uniqueRelatedDocuments];
          } else {
            data = [];
          }
        } else {
          dispatch(setRelatedUnmatchedDocIds([]));
          dispatch(setRelatedUnmatchedDocuments([]));
          data = rows[selectedTab];
        }
      }
    }

    // Create a mapping to store children for each parent
    const childrenMap: Record<string, any[]> = {};
    data &&
      data.forEach((item) => {
        if (item.parent) {
          if (!childrenMap[item.parent]) {
            childrenMap[item.parent] = [];
          }
          childrenMap[item.parent].push(item);
        }
      });

    let matchedDocs: string[] = [];

    if (sideBarLevelToDocIds) {
      matchedDocs =
        sideBarLevelToDocIds[sideBarSelectedTree][selectedPivotValue];
    }

    // function getCaseInsensitiveValue<T>(
    //   obj: Record<string, T>,
    //   key: string
    // ): T | undefined {
    //   const foundKey = Object.keys(obj).find(
    //     (k) => k.toLowerCase() === key.toLowerCase()
    //   );
    //   return foundKey ? obj[foundKey] : undefined;
    // }

    // if (sideBarLevelToDocIds) {
    //   if (sideBarSelectedTree === selectedPivotValue.split("^^^")[0]) {
    //     // means its the tree header like reminder or inbox
    //     matchedDocs = [
    //       ...Object.values(
    //         getCaseInsensitiveValue(
    //           sideBarLevelToDocIds,
    //           sideBarSelectedTree
    //         ) || {}
    //       ).flat(),
    //     ];
    //   } else {
    //     matchedDocs = [
    //       ...(getCaseInsensitiveValue(
    //         getCaseInsensitiveValue(
    //           sideBarLevelToDocIds,
    //           sideBarSelectedTree
    //         ) || {},
    //         selectedPivotValue
    //       ) || []),
    //     ];
    //   }
    // }

    const documentMatchingConstraints = data
      .filter((doc) => {
        if (selectedSideBarTree === SIDE_BAR_TREE.REMINDER) {
          if (selectReminderParentNode !== "" && doc.reminderDate) {
            const targetDate = moment(doc.reminderDate, "YYYY-MM-DDTHH:mm:ss");
            const today = moment().startOf("day");

            const diff = targetDate.diff(today, "days");
            if (
              (selectReminderParentNode.includes(REMINDER_PAST_DUE) &&
                diff < 0) ||
              (selectReminderParentNode.includes(REMINDER_TODAY) &&
                diff == 0) ||
              (selectReminderParentNode.includes(REMINDER_TOMORROW) &&
                diff == 1) ||
              (selectReminderParentNode.includes(REMINDER_IN_2_DAYS) &&
                diff == 2) ||
              (selectReminderParentNode.includes(REMINDER_IN_3_DAYS) &&
                diff == 3) ||
              (selectReminderParentNode.includes(REMINDER_IN_4_DAYS) &&
                diff == 4) ||
              (selectReminderParentNode.includes(REMINDER_IN_5_DAYS) &&
                diff == 5) ||
              (selectReminderParentNode.includes(REMINDER_IN_6_DAYS) &&
                diff == 6) ||
              (selectReminderParentNode.includes(REMINDER_IN_1_WEEK_OR_MORE) &&
                diff >= 7) ||
              selectReminderParentNode ===
                "27b70407-ac0a-4050-8983-e54e3e81df11"
            ) {
              return true;
            }
          }
          return false;
        } else {
          return true;
        }
      })
      .filter((doc) => {
        if (matchedDocs && matchedDocs.length > 0)
          return matchedDocs?.includes(doc.id);
        else return true;
      })
      // .map((doc) => doc.id);
      // .filter((doc) => {
      //   if (
      //     selectedPivotValue.length > 0 &&
      //     !Object.keys(SIDE_BAR_TREE).includes(
      //       selectedPivotValue[0].toUpperCase()
      //     ) &&
      //     !Object.keys(REMINDER_TREE_ROOT_NODES).includes(
      //       selectedPivotValue[0].toUpperCase()
      //     )
      //   ) {
      //     let textToMatch = selectedPivotValue.at(-1)?.toLowerCase() || "";
      //     if (textToMatch === "<empty>") {
      //       textToMatch = "---";
      //     }
      //     return doc.values.some((v) => {
      //       if (
      //         Object.values(REMINDER_TREE_ROOT_NODES)
      //           .map((r) => r.toLowerCase())
      //           .includes(selectedPivotValue[0].toLowerCase())
      //       ) {
      //         return true;
      //       } else if (v.value.toLowerCase() === textToMatch) {
      //         return true;
      //       } else {
      //         if (v.field === "003m") {
      //           return states
      //             .filter(
      //               (state) =>
      //                 state.name.toLowerCase() === v.value.toLowerCase() ||
      //                 state.abbr.toLowerCase() === v.value.toLowerCase()
      //             )
      //             .map((s) => s.name.toLowerCase())
      //             .includes(textToMatch);
      //           // .some((state) =>
      //           //   new Set(
      //           //     selectedPivotValue.map((pivot) => pivot.toLowerCase())
      //           //   ).has(state)
      //           // );
      //         } else {
      //           return false;
      //         }
      //       }
      //     });
      //   } else {
      //     return true;
      //   }
      // })
      .map((doc) => doc.id);
    // Get IDs of documents that match the pivot criteria

    const parentsForMatchingConstraints = data
      .filter(
        (doc) =>
          documentMatchingConstraints.includes(doc.id) && doc.parent !== ""
      )
      .map((doc) => doc.parent); // Get parent IDs for matching documents

    let consolidatedData = data.filter(
      (doc) => documentMatchingConstraints.includes(doc.id)
      // || parentsForMatchingConstraints.includes(doc.id)
    );

    if (isReadOnly) {
      let parentIds = Object.keys(childrenMap);
      const availableParentIds = data
        .filter((s) => s.parent === "")
        .map((s) => s.id);

      const missingIds = parentIds.filter(
        (id) => !availableParentIds.includes(id)
      );

      const seen = new Map<String, DocumentEntity>();
      Object.values(rows)
        .flat()
        .filter((s) => s.parent === "")
        .forEach((item) => {
          seen.set(item.id, item);
        });

      const deduped = Array.from(seen.values());

      const missingDoc = deduped.filter((d) => missingIds.includes(d.id));

      consolidatedData = data.concat(missingDoc);
    }

    const sortedData =
      consolidatedData &&
      [...consolidatedData].sort((a, b) => {
        const statusA = a.status?.toLowerCase() || "";
        const statusB = b.status?.toLowerCase() || "";
        // If lease filter is active, sort by status first, then uploaded date desc,then dashboard order
        if (!isLeaseFilterStatusActive) {
          // if (statusA < statusB) return -1;
          // if (statusA > statusB) return 1;
          const customOrder = [
            "active",
            "in_lease",
            "executed_lease",
            "dead_deal",
          ];
          const statusIndexA = customOrder.indexOf(statusA);
          const statusIndexB = customOrder.indexOf(statusB);
          if (statusIndexA !== statusIndexB) return statusIndexA - statusIndexB;
        }

        // Fallback to timestamp and dashboardOrder
        const tsA = new Date(a.ts).getTime();
        const tsB = new Date(b.ts).getTime();

        return tsB - tsA || Number(b.dashboardOrder) - Number(a.dashboardOrder);
      });

    // Rearrange the array by grouping parents and their children
    const arrangedData: any[] = [];
    sortedData &&
      sortedData.forEach((item) => {
        if (!item.parent) arrangedData.push(item);
        if (childrenMap[item.id] && expandedParent === item.id) {
          // Add children sorted by ts in descending order
          arrangedData.push(
            ...childrenMap[item.id].sort((a, b) => b.grpOrder - a.grpOrder)
          );
        }
      });
    return arrangedData;
  }, [
    rows,
    selectedTab,
    expandedParent,
    parentsWithChildren,
    isLeaseFilterStatusActive,
    selectedPivotValue,
    sideBarLevelToDocIds,
    selectedSideBarTree,
  ]);

  // useEffect(() => {
  //   if (rows[selectedTab]) {
  //     gridRef.current!.api.setRowData(rows[selectedTab]);
  //     gridRef.current!.api.redrawRows();
  //   }
  // }, [selectedTab]);

  useEffect(() => {
    if (inboxTabId != undefined && !_.isEmpty(rows))
      if (inboxTabId in rows) {
        var newParentsWithChildren: string[] = [];
        rows[inboxTabId] &&
          rows[inboxTabId].forEach((doc) => {
            if (doc.parent !== "") {
              if (!newParentsWithChildren.includes(doc.parent)) {
                newParentsWithChildren.push(doc.parent);
              }
            }
          });
        dispatch(
          setParentsWithChildren(
            _.uniq([...parentsWithChildren, ...newParentsWithChildren])
          )
        );
      }
  }, [rows]);

  const components = useMemo(
    () => ({
      agColumnHeader: TableHeader,
    }),
    []
  );

  function transformHeaders(headers: FieldEntity[]): ColDef[] {
    // Prepare the Column Defination
    function prepareColDef(header: FieldEntity) {
      // if (header.code == CUSTOM_COLUMN_KEY.AUTHOR && header.code == CUSTOM_COLUMN_KEY.TRADE_AREA && header.code == CUSTOM_COLUMN_KEY.MARKET) {
      //   return
      // }
      // Default Column Def
      let colDef: ColDef = {
        colId:
          header.code === CUSTOM_COLUMN_KEY.NOTES_HIDDEN ||
          CUSTOM_COLUMN_KEY.STATUS_HIDDEN ||
          CUSTOM_COLUMN_KEY.REMINDER_HIDDEN ||
          CUSTOM_COLUMN_KEY.DOCUMENT_HIDDEN
            ? header.code
            : header.name,
        headerName: header.name,
        pinned: isColumnPinnedAndLocked(header.pinned, header.order),
        lockPinned: true, //prevents columns to get stuck to pinned columns
        headerComponentParams: {
          customData: header,
        },
        headerClass: (params) => {
          const classNames = [];
          // if (header.order < 0 || header.order == 100 || header.order == 101) {
          if (header.order == 102) {
            classNames.push("pinned-column-header");
          } else if (
            isColumnPinnedAndLocked(header.pinned, header.order) != null
          ) {
            classNames.push("pinned-column-header");
          } else {
            classNames.push("normal-column-color");
          }
          return classNames;
        },
        wrapHeaderText: true,
        wrapText: true,
        cellClass: (params) => {
          const classNames: string[] = [];
          if (params.data.id == selectedDocumentId) {
            classNames.push("selected-row-color");
          } else {
            if (header.order == -5 || header.order == 102) {
              classNames.push("pinned-column-cell-color");
            } else if (header.order == 0) {
              classNames.push("market-column");
            }
          }
          if (header.code == CUSTOM_COLUMN_KEY.REMINDER || header.code == CUSTOM_COLUMN_KEY.REMINDER_HIDDEN) {
            classNames.push("ag-reminder-holder");
          }
          if (header.code == CUSTOM_COLUMN_KEY.NOTES_HIDDEN) {
            classNames.push(CUSTOM_COLUMN_KEY.NOTES_HIDDEN);
          }
          if (header.code === CUSTOM_COLUMN_KEY.CHILDREN) {
            classNames.push("expand-collapse-parent-div");
          }
          return classNames;
        },
        cellClassRules: {
          "tc-dead-deal": (params) => params.value === LEASE_STATUS.DEAD_DEAL,
          "tc-cell-in-lease": (params) =>
            params.value === LEASE_STATUS.IN_LEASE,
          "tc-lease-executed": (params) =>
            params.value === LEASE_STATUS.EXECUTED_LEASE,
          "tc-active-lease": (params) =>
            ![
              LEASE_STATUS.DEAD_DEAL,
              LEASE_STATUS.IN_LEASE,
              LEASE_STATUS.EXECUTED_LEASE,
            ].includes(params.value),
        },
        minWidth: 25,
        suppressSizeToFit: true,
        suppressMovable:
          header.order < 0 || header.order >= 100 || isReadOnly ? true : false,
        resizable: header.order !== 102 || !isReadOnly ? true : false,
        width:
          getColumnWidth(header.code) +
          getColumnWidth(header.code) * header.widthChange,
        lockPosition: header.pinned
          ? header.order < 0
            ? "left"
            : header.order > 100
            ? "right"
            : undefined
          : undefined,
        initialHide:
          header.code == CUSTOM_COLUMN_KEY.NOTES_HIDDEN ||
          header.code == CUSTOM_COLUMN_KEY.STATUS_HIDDEN ||
          header.code == CUSTOM_COLUMN_KEY.REMINDER_HIDDEN ||
          header.code == CUSTOM_COLUMN_KEY.DOCUMENT_HIDDEN
            ? true
            : false,
        cellRenderer: TableCell,
        cellRendererParams: { customData: header },
      };

      if (header.order < 0) {
        colDef["lockPosition"] = "left";
      } else if (header.order >= 100) {
        colDef["lockPosition"] = "right";
      }

      if (header.code === "notes") {
        colDef.suppressKeyboardEvent = suppressArrowNavigation;
      }
      // colDef["cellRenderer"] = TableCell;
      // colDef["cellRendererParams"] = { customData: header };

      // if (header.code === 'trade') {
      //   colDef['editable'] = true;
      // }

      return colDef;
    }

    function suppressArrowNavigation(
      params: SuppressKeyboardEventParams
    ): boolean {
      const key = params.event.key;

      return (
        key === "ArrowUp" ||
        key === "ArrowDown" ||
        key === "ArrowLeft" ||
        key === "ArrowRight"
      );
    }

    function isColumnPinnedAndLocked(customPinned: boolean, order: number) {
      if (order < 0 || customPinned) {
        return "left";
      } else if (order >= 100) {
        return "right";
      }
      return null;
    }

    const tempHeaders = headers.filter(
      (e) =>
        ![
          CUSTOM_COLUMN_KEY.AUTHOR,
          CUSTOM_COLUMN_KEY.MARKET,
          CUSTOM_COLUMN_KEY.TRADE_AREA,
        ].includes(e.code)
    );

    return [...tempHeaders]
      .sort((h1, h2) => h1.order - h2.order)
      .map((header) => prepareColDef(header));
  }

  // function prepareRows(rows: DType[], filterBy: string) {
  function prepareRows(rows: DocumentEntity[]) {
    let fieldValues: DocumentEntity[] = rows;
    return fieldValues;
  }

  const getRowId = useMemo<GetRowIdFunc>(() => {
    return (params: GetRowIdParams<DocumentEntity>) => params.data.id;
  }, []);

  const isRowSelectable = (rowData: IRowNode<DocumentEntity>) => {
    return rowData.data?.status != LEASE_STATUS.DUMMY;
  };

  const handleCellClick = (event: CellClickedEvent) => {
    const restrictiveFieldCodes = ["Children"];
    const headersName = headers
      .filter((header) => restrictiveFieldCodes.indexOf(header.name) >= 0)
      .map((header) => header.name);

    if (event.colDef.colId && headersName.indexOf(event.colDef.colId) >= 0) {
      if (event.colDef.colId === "Children") {
        return;
      } else if (event.colDef.colId === "LOI Status") {
        // displayMenu(event, event.node.data, MENU_SUB_TYPE.AUTHOR);
      }
    } else {
      gridRef.current?.api.forEachNode(function (rowNode) {
        if (rowNode.data?.id && rowNode.isSelected()) {
          if (!rowNode.data.read) {
            updateDocumentReadStatus(rowNode.data?.id, true, false)?.then(
              () => {
                dispatch(
                  markDocumentRead({
                    clientId: selectedTab,
                    documentId: rowNode.data?.id,
                    status: true,
                  })
                );
                dispatch(
                  updateDocumentStatusForReadStatus({
                    documentId: rowNode.data?.id,
                    isRead: true,
                  })
                );
                dispatch(updateRowReadStatus(true)).then(() =>
                  updateDocumentReadStatus(rowNode.data?.id, true, false)
                );
              }
            );
          }
          if (event.colDef.colId === "children") {
            rowNode.setRowHeight(
              userInActiveLine * userTableFontSize * userLineHeight +
                userCellPadding * 2
            );
          } else {
            dispatch(setDocumentRowAsExpanded(event.data));
            rowNode.setRowHeight(
              userActiveLine * userTableFontSize * userLineHeight +
                userCellPadding * 2
            );
          }
        } else {
          if (!rowNode.data?.locked)
            rowNode.setRowHeight(
              userInActiveLine * userTableFontSize * userLineHeight +
                userCellPadding * 2
            );
        }
      });
      event.api.onRowHeightChanged();
    }
  };

  // handle the row selection
  // const handleRowSelection = (event: RowSelectedEvent) => {
  //   gridRef.current?.api.forEachNode(function (rowNode) {
  //     if (rowNode.data?.id && rowNode.isSelected()) {
  //       rowNode.setRowHeight(
  //         resMetadata.headerLineHeight * 10 + userCellPadding * 2
  //       );
  //     } else {
  //       if (!rowNode.data?.locked) rowNode.setRowHeight(uiInactiveRowHeight);
  //     }
  //   });
  //   event.api.onRowHeightChanged();
  //   dispatch(setSelectedDocument(event.data));
  // };

  // Show abstraction on the double click
  const handleCellDoubleClick = useCallback(
    (event: CellDoubleClickedEvent) => {
      const isUnMatchedDocument =
        rows?.[selectedTab]?.findIndex((e) => e.id === event.data.id) === -1;

      if (event.colDef.colId === "children") {
        return;
      }
      if (isUnMatchedDocument) {
        return;
      }

      gridRef.current?.api.forEachNode(function (rowNode) {
        if (rowNode.data?.id && rowNode.isSelected()) {
          if (!rowNode.data.read) {
            updateDocumentReadStatus(rowNode.data?.id, true, false)?.then(
              () => {
                dispatch(
                  markDocumentRead({
                    clientId: selectedTab,
                    documentId: rowNode.data?.id,
                    status: true,
                  })
                );
                dispatch(
                  updateDocumentStatusForReadStatus({
                    documentId: rowNode.data?.id,
                    isRead: true,
                  })
                );
                dispatch(updateRowReadStatus(true)).then(() =>
                  updateDocumentReadStatus(rowNode.data?.id, true, false)
                );
              }
            );
          }
        }
      });
      const fieldCode = event.colDef.colId;
      const fieldValue = event.data?.values.filter(
        (e: any) => e.field === fieldCode
      )[0]?.value;
      dispatch(
        setFieldToBeSelectedInEdit({ fieldCode: fieldCode, value: fieldValue })
      );
      dispatch(setMenu(NONE_MENU_ID));
      dispatch(setAbstraction());
      // dispatch(getFilterListForDocument({documentId:event.data.id}))
      dispatch(fetchDocumentHTML());
    },
    [rows, selectedTab]
  );

  const handleClick = (event: CellClickedEvent | CellDoubleClickedEvent) => {
    dispatch(setSelectedDocument(event.data));
    if (clickTimeout) {
      clearTimeout(clickTimeout);
      setClickTimeout(null);
      handleCellDoubleClick(event);
      if (lastExpandStatus !== null) setExpandTo10Rows(lastExpandStatus);
      setLastExpandStatus(null);
    } else {
      if (
        event.colDef?.colId === CUSTOM_COLUMN_KEY.CHILDREN ||
        event.colDef?.colId === CUSTOM_COLUMN_KEY.PIN ||
        event.colDef?.colId === CUSTOM_COLUMN_KEY.NOTES ||
        event.colDef?.colId === CUSTOM_COLUMN_KEY.STATUS ||
        event.colDef?.colId === CUSTOM_COLUMN_KEY.REMINDER ||
        event.colDef?.colId === CUSTOM_COLUMN_KEY.REMINDER_HIDDEN
      ) {
        if (selectedDocumentId !== event.data.id) {
          gridRef.current?.api?.forEachNode(function (rowNode) {
            if (
              !rowNode.data?.locked &&
              !rowNode.isSelected() &&
              userInActiveRowHeight > 0
            ) {
              rowNode.setRowHeight(
                userInActiveLine * uiTableFontSize * userLineHeight +
                  userCellPadding * 2
              );
            }
          });
          setExpandTo10Rows(false);
          handleScrollSizeChange();
        }
        return;
      }
      if (selectedDocumentId === event.data.id) {
        const isMouseClick = event.event instanceof MouseEvent;
        const isShiftHeld =
          event.event instanceof MouseEvent && event?.event?.shiftKey;
        if (!parentsWithChildren.includes(event.data.id)) {
          if (isMouseClick && isShiftHeld) {
            setExpandTo10Rows((prev) => !prev);
          }
        } else {
          if (!isMouseClick || !isShiftHeld) {
            handleRowExpandCollapse(event.data.id);
          } else {
            setExpandTo10Rows((prev) => !prev);
          }
        }
      } else {
        setExpandTo10Rows(false);
      }

      const timeout = setTimeout(() => {
        handleCellClick(event);
        setClickTimeout(null);
      }, 210) as NodeJS.Timeout;
      setClickTimeout(timeout);
    }
  };

  const isExternalFilterPresent = useCallback(() => {
    return true;
  }, []);

  const doesExternalFilterPass = useCallback(
    (node: IRowNode<DocumentEntity>) => {
      const appliedFilters = leaseStatusFilters
        .filter((filter) => filter.selected)
        .map((filter) => filter.name);
      if (node.data) {
        const lStatus = node.data.status;
        if (appliedFilters.includes(lStatus)) {
          return true;
        }
      }
      return false;
    },
    [leaseStatusFilters]
  );

  useEffect(() => {
    gridRef.current?.api?.onFilterChanged();
  }, [leaseStatusFilters]);

  const scrollWidth = document.getElementsByClassName(
    "ag-body-vertical-scroll"
  )[0]?.clientWidth;
  // Aligining Deal Notes to factor customized scroll design
  useEffect(() => {
    window.addEventListener("resize", handleScrollSizeChange);
    return () => {
      window.removeEventListener("resize", handleScrollSizeChange);
    };
  }, [rows, scrollWidth]);

  const handleScrollSizeChange = () => {
    setTimeout(() => {
      const width =
        document.getElementsByClassName("ag-body-vertical-scroll")[0]
          ?.clientWidth || 0;
      var pinnedRightHeader = document.querySelector(".ag-pinned-right-header");
      if (width > 0) {
        pinnedRightHeader?.classList.remove(
          "ag-pinned-right-header-without-scroll"
        );
        pinnedRightHeader?.classList.add("ag-pinned-right-header-with-scroll");
      } else {
        pinnedRightHeader?.classList.add(
          "ag-pinned-right-header-without-scroll"
        );
        pinnedRightHeader?.classList.remove(
          "ag-pinned-right-header-with-scroll"
        );
      }
    }, 500);
  };

  let resizeTimer: ReturnType<typeof setTimeout>;
  const handleColResize = (event: ColumnResizedEvent) => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      onColumnResized(event);
    }, 300);
  };

  function onColumnResized(event: ColumnResizedEvent) {
    let fieldEntity: FieldEntity =
      event.column?.getColDef().cellRendererParams.customData;
    let widthChange =
      ((event.column?.getActualWidth() || 0) -
        getColumnWidth(fieldEntity?.code)) /
      getColumnWidth(fieldEntity?.code);
    dispatch(updateFieldResize({ ...fieldEntity, widthChange }));
  }

  useEffect(() => {
    if (gridRef.current) {
      gridRef.current.forceUpdate();
    }
  }, [transformedRowsData]);

  // Drag Functions
  const dropOverIdCSSRef = useRef("");
  const dropOverOrderRef = useRef<Number>(-1);

  function validDropZone(event: RowDragMoveEvent) {
    const gridElement = document.querySelector(
      ".ag-root-wrapper"
    ) as HTMLElement;
    const rect = gridElement?.getBoundingClientRect();
    const mouseX = event?.event.clientX;
    const mouseY = event?.event.clientY;
    if (
      mouseY > gridElement?.scrollHeight + 10 ||
      mouseX < rect?.left + 10 ||
      mouseX > rect?.right - 10 ||
      mouseY < 110
    ) {
      const prevDraggedId = dropOverIdCSSRef.current;
      if (prevDraggedId) {
        removeSortDropHighlight(prevDraggedId);
      }
      return false;
    } else {
      return true;
    }
  }

  function onDragMove(event: RowDragMoveEvent) {
    dispatch(setMenu(NONE_MENU_ID));
    const draggedDoc = event.node.data;
    let dropOverDoc = event.overNode?.data;
    const prevDraggedId = dropOverIdCSSRef.current;
    if (!validDropZone(event)) {
      return;
    }

    // if (expandedParent !== dropOverDoc?.id && dropOverDoc?.parent === '') {
    //   handleRowExpandCollapse(dropOverDoc?.id);
    // }
    if (prevDraggedId) {
      removeSortDropHighlight(prevDraggedId);
    }
    dropOverOrderRef.current = -1;
    if (
      dropOverDoc?.parent === "" &&
      draggedDoc?.parent !== "" &&
      // || (draggedDoc?.parent === '' && dropOverDoc?.parent !== ''))
      draggedDoc?.id !== dropOverDoc?.parent &&
      draggedDoc?.parent !== dropOverDoc?.id
    ) {
      return;
    }
    if (event.overIndex >= 0) {
      const dropCSSId = event.overNode?.data?.id;
      dropOverIdCSSRef.current = dropCSSId;
      let loiToBeModified = event.overNode?.data?.id;
      let classToBeAdded = "";

      const isDraggedNotOutsideGroup =
        draggedDoc.id !== dropOverDoc.parent ||
        dropOverDoc.id !== draggedDoc.parent;
      const isSortingWithInGroup =
        (dropOverDoc.parent !== "" &&
          draggedDoc.parent !== "" &&
          dropOverDoc.parent === draggedDoc.parent) ||
        dropOverDoc.parent === draggedDoc.id ||
        dropOverDoc.id === draggedDoc.parent;
      const isDropNotOnSameDoc = draggedDoc.id !== dropOverDoc.id;
      // Drag Sorting
      if (
        isDropNotOnSameDoc &&
        isSortingWithInGroup &&
        isDraggedNotOutsideGroup
      ) {
        if (
          // Dragging a Child LOI, Dragged LOI order < Dropover LOI order
          (draggedDoc.parent !== "" &&
            dropOverDoc.grpOrder >= draggedDoc.grpOrder) ||
          // Dragging a Child LOI , parent change
          draggedDoc.parent === dropOverDoc.id
        ) {
          classToBeAdded = "row-sort-over-up";
        } else {
          classToBeAdded = "row-sort-over-down";
        }

        // When user sort drags a doc over an expanded group
        // if (
        //   parentsWithChildren.includes(groupParentDoc?.id) &&
        //   expandedParent === groupParentDoc?.id && // checks whether its a parent and expanded
        //   draggedDoc.parent !== dropOverDoc.id && // Whether child changes parent posiiton
        //   ((draggedDoc.parent === "" && dropOverDoc.parent === "") || // Group LOIs need not come
        //     (draggedDoc.parent !== dropOverDoc.parent &&
        //       draggedDoc.id !== dropOverDoc.parent))
        // ) {
        //   if (groupParentDoc?.dashboardOrder < draggedDoc?.dashboardOrder) {
        //     loiToBeModified = lastChildOfGroup?.id;
        //   } else {
        //     loiToBeModified = lastChildOfGroup?.parent;
        //   }
        //   dropOverOrderRef.current = groupParentDoc?.dashboardOrder;
        // }
      } else {
        // Drag Grouping
        if (
          (draggedDoc?.parent !== dropOverDoc?.parent ||
            (draggedDoc?.parent === "" && dropOverDoc?.parent === "")) &&
          draggedDoc?.parent !== dropOverDoc?.id &&
          (!parentsWithChildren.includes(draggedDoc?.id) ||
            !parentsWithChildren.includes(dropOverDoc?.id)) &&
          !parentsWithChildren.includes(draggedDoc?.id)
        )
          classToBeAdded = "row-drop-over";
        else return;
      }
      const dropOverDocEl = document.querySelectorAll(
        `[row-id="${loiToBeModified}"]`
      );
      dropOverDocEl &&
        dropOverDocEl.forEach((el) => el.classList.add(classToBeAdded));
      dropOverIdCSSRef.current = loiToBeModified;
    }
  }

  function handleDragGrouping(
    event: RowDragEndEvent,
    draggedDoc: DocumentEntity,
    dropOverDoc: DocumentEntity
  ) {
    const dropOverDocId =
      event.overNode?.data?.parent === ""
        ? event.overNode?.data?.id
        : event.overNode?.data?.parent;
    // Drag an orphan to make grouping
    if (
      draggedDoc.parent !== "" &&
      draggedDoc.parent === event.overNode?.data?.parent
    ) {
      dispatch(
        dragLeaseMapping({
          parentId: draggedDoc.parent,
          childId: draggedDoc.id,
          newChildDocOrder: dropOverDoc.order,
        })
      ).then((res) => {
        if (res) {
          return;
        }
      });
    } else if (
      draggedDoc.parent === "" &&
      dropOverDocId !== draggedDoc.id &&
      dropOverDoc?.id &&
      !parentsWithChildren.includes(draggedDoc.id) // To check parent ungrouping
    ) {
      let groupPayload = {
        parentId: dropOverDocId,
        childId: draggedDoc.id,
        newChildDocOrder: dropOverDoc.grpOrder,
      };
      if (parentsWithChildren.includes(draggedDoc?.id)) {
        groupPayload.parentId = draggedDoc.id;
        groupPayload.childId = dropOverDocId;
        groupPayload.newChildDocOrder = 0;
      }
      dispatch(dragLeaseMapping(groupPayload)).then((res) => {
        if (res) {
          // dispatch(setDocumentExpanded(groupPayload?.parentId));
          if (expandedParent !== groupPayload?.parentId) {
            handleRowExpandCollapse(groupPayload?.parentId);
          }
        }
      });
    }
  }

  function handleDragUnGrouping(
    event: RowDragEndEvent,
    draggedDoc: DocumentEntity,
    dropOverDoc: DocumentEntity
  ) {
    const isParentBeingUngrouped = draggedDoc?.parent === "";
    let ungroupPayload = {
      parentId: "",
      childId: draggedDoc?.id,
      newChildDocOrder:
        dropOverDoc?.dashboardOrder || draggedDoc?.dashboardOrder || 0,
      isParentChange: isParentBeingUngrouped,
    };
    const parentId = isParentBeingUngrouped ? draggedDoc.id : draggedDoc.parent;
    const isOnlyChild =
      inboxDocuments.filter((e) => e.parent === parentId).length === 1;
    if (isOnlyChild && expandedParent === parentId) {
      // Manual update the db to collapse state
      handleRowExpandCollapse(parentId);
    }
    dispatch(dragLeaseMapping(ungroupPayload)).then((res) => {
      if (res?.payload) {
        dispatch(checkAndRemoveParentFromDocuments(parentId)); // this is the dispatch to action that checks if a parent has remaining children if not then it updates the parentswithchildren state in stor
        removeChildHighlight(draggedDoc.id);
        removeSortDropHighlight(draggedDoc.id);
        dispatch(unGroupLeaseDoc({ inboxTabId, draggedDoc }));
      }
    });
  }

  function handleDragSorting(
    event: RowDragEndEvent,
    draggedDoc: DocumentEntity,
    dropOverDoc: DocumentEntity
  ) {
    dispatch(setMenu(NONE_MENU_ID));
    let overIndex;
    if (
      dropOverDoc?.parent === "" &&
      draggedDoc?.parent !== "" &&
      // || (draggedDoc?.parent === '' && dropOverDoc?.parent !== ''))
      draggedDoc?.id !== dropOverDoc?.parent &&
      draggedDoc?.parent !== dropOverDoc?.id
    ) {
      return;
    }
    if (draggedDoc.parent === "") {
      overIndex = dropOverDoc?.dashboardOrder;
    } else {
      dispatch(checkAndRemoveParentFromDocuments(draggedDoc.parent));
      overIndex = dropOverDoc?.grpOrder;
    }

    // Dragging Parent to Child
    if (draggedDoc?.id === dropOverDoc?.parent) {
      const nextParent = rows[selectedTab]
        ?.filter((e) => e.parent === draggedDoc.id)
        .sort((a, b) => Number(b.grpOrder) - Number(a.grpOrder))[0];
      dispatch(
        dragLeaseMapping({
          parentId: dropOverDoc?.parent,
          childId: dropOverDoc?.id,
          newChildDocOrder: dropOverDoc?.grpOrder,
          isParentChange: true,
        })
      ).then(() => {
        // removeGreyGroupShadow(expandedParent);
        setTimeout(() => {
          handleRowExpandCollapse(nextParent?.id);
          dispatch(updateParentsWithChildren(draggedDoc?.id));
        }, 100);
      });
      return;
    }

    // Dragging Child to change Parent
    if (draggedDoc?.parent === dropOverDoc?.id) {
      dispatch(
        dragLeaseMapping({
          parentId: draggedDoc.parent,
          childId: draggedDoc.id,
          newChildDocOrder: 0,
          isParentChange: true,
        })
      ).then(() => {
        // removeGreyGroupShadow(expandedParent);
        setTimeout(() => {
          // dispatch(setDocumentExpanded(draggedDoc.id));
          handleRowExpandCollapse(draggedDoc?.id);
          dispatch(updateParentsWithChildren(dropOverDoc?.id));
        }, 10);
      });
      return;
    }
    dispatch(
      dragLeaseMapping({
        parentId: draggedDoc.parent,
        childId: draggedDoc.id,
        newChildDocOrder:
          Number(dropOverOrderRef.current) > -1
            ? dropOverOrderRef.current
            : overIndex,
        isParentChange: false,
      })
    );
    dropOverOrderRef.current = -1;
  }

  function onDragEnd(event: RowDragEndEvent) {
    const draggedDoc = event.node.data;
    const dropOverDoc = event.overNode?.data;
    const isSortingWithInGroup =
      (dropOverDoc?.parent !== "" &&
        draggedDoc.parent !== "" &&
        dropOverDoc?.parent === draggedDoc.parent) ||
      dropOverDoc?.parent === draggedDoc.id ||
      dropOverDoc?.id === draggedDoc.parent;
    const isDropOnSameDoc = draggedDoc.id === dropOverDoc?.id;
    if (!isSortingWithInGroup || isDropOnSameDoc) {
      const isDocInsideGroup =
        parentsWithChildren.includes(draggedDoc.id) ||
        parentsWithChildren.includes(draggedDoc?.parent);
      if (isDocInsideGroup) {
        handleDragUnGrouping(event, draggedDoc, dropOverDoc);
      } else if (
        draggedDoc?.parent === "" &&
        draggedDoc?.parent !== dropOverDoc?.id &&
        (!parentsWithChildren.includes(draggedDoc?.id) ||
          !parentsWithChildren.includes(dropOverDoc?.id)) &&
        !parentsWithChildren.includes(draggedDoc?.id)
      ) {
        handleDragGrouping(event, draggedDoc, dropOverDoc);
      } else return;
    } else if (draggedDoc?.id !== dropOverDoc?.id) {
      handleDragSorting(event, draggedDoc, dropOverDoc);
    }
    removeSortDropHighlight(dropOverDoc?.id);
    const prevDraggedId = dropOverIdCSSRef.current;
    if (prevDraggedId) {
      removeSortDropHighlight(prevDraggedId);
    }
  }

  function removeSortDropHighlight(divId: string) {
    const elToBeModified = document.querySelectorAll(`[row-id="${divId}"]`);
    elToBeModified &&
      elToBeModified.forEach((el) => {
        el.classList.remove(
          "row-drop-over",
          "row-sort-over-up",
          "row-sort-over-down"
        );
      });
  }

  function removeChildHighlight(divId: string) {
    const elToBeModified = document.querySelectorAll(`[row-id="${divId}"]`);
    elToBeModified &&
      elToBeModified.forEach((el) => {
        el.classList.remove(
          "row-child-lease",
          "row-drop-over-child",
          "row-drop-over",
          "row-sort-over-up",
          "row-sort-over-down"
        );
      });
    if (parentsWithChildren.includes(divId)) {
      const childIds = transformedRowsData
        .filter((e) => e.parent === divId)
        .map((e) => e.id);
      childIds.forEach((e) => removeChildHighlight(e));
    }
  }

  function regulateParentChildShadow() {
    // removeGreyGroupShadow(prevExpandedParent);

    // Removing prev bg changes
    if (prevExpandedParent !== "") {
      const prevDocIndex = transformedRowsData.findIndex(
        (e) => e.id === prevExpandedParent
      );
      const { beforeDocId, afterDocId } = getBeforeAfterDocIds(prevDocIndex);
      document
        .querySelectorAll(`[row-id="${prevExpandedParent}"]`)
        .forEach((el) => {
          el.classList.remove(
            "row-child-lease",
            "before-btm-expand-lease",
            "after-top-expand-lease"
          );
        });
      document.querySelectorAll(`[row-id="${beforeDocId}"]`).forEach((el) => {
        el.classList.remove(
          "row-child-lease",
          "before-btm-expand-lease",
          "after-top-expand-lease"
        );
      });
      document.querySelectorAll(`[row-id="${afterDocId}"]`).forEach((el) => {
        el.classList.remove(
          "row-child-lease",
          "before-btm-expand-lease",
          "after-top-expand-lease"
        );
      });
      document
        .querySelectorAll(`[row-id="${beforeShadowRef.current}"]`)
        ?.forEach((el) => {
          el.classList.remove(
            // "row-child-lease",
            "before-btm-expand-lease",
            "after-top-expand-lease"
          );
        });
      document
        .querySelectorAll(`[row-id="${afterShadowRef?.current}"]`)
        ?.forEach((el) => {
          el.classList.remove(
            // "row-child-lease",
            "before-btm-expand-lease",
            "after-top-expand-lease"
          );
        });
    }

    // applying latest changes
    if (expandedParent !== "" && parentsWithChildren.includes(expandedParent)) {
      const docIndex = transformedRowsData.findIndex(
        (e) => e.id === expandedParent
      );
      const { beforeDocId, afterDocId } = getBeforeAfterDocIds(docIndex);
      beforeShadowRef.current = beforeDocId;
      afterShadowRef.current = afterDocId;
      const visibleChildIds = transformedRowsData
        .filter((e) => e.parent === expandedParent)
        .map((e) => e.id);
      visibleChildIds.forEach((childId) => {
        document.querySelectorAll(`[row-id="${childId}"]`).forEach((el) => {
          el.classList.add("row-child-lease");
        });
      });
      document
        .querySelectorAll(`[row-id="${expandedParent}"]`)
        .forEach((el) => {
          el.classList.add("row-child-lease");
        });
      document.querySelectorAll(`[row-id="${beforeDocId}"]`).forEach((el) => {
        el.classList.add("before-btm-expand-lease");
      });
      document.querySelectorAll(`[row-id="${afterDocId}"]`).forEach((el) => {
        el.classList.add("after-top-expand-lease");
      });
    }
  }

  function getBeforeAfterDocIds(docIndex: number) {
    // Find the closest 'parent'='' before the current index
    let beforeDocId = null;
    for (let i = docIndex - 1; i >= 0; i--) {
      if (transformedRowsData[i].parent === "") {
        beforeDocId = transformedRowsData[i].id;
        break;
      }
    }

    // Find the closest 'parent'='' after the current index
    let afterDocId = null;
    for (let i = docIndex + 1; i < transformedRowsData.length; i++) {
      if (transformedRowsData[i].parent === "") {
        afterDocId = transformedRowsData[i].id;
        break;
      }
    }

    return { beforeDocId, afterDocId };
  }

  const handleColumnDrag = useCallback(
    (event: ColumnMovedEvent) => {
      if (event.finished) {
        const draggedCol =
          event.column?.getColDef()?.headerComponentParams?.customData;
        if (draggedCol) {
          const rangeHeaders = [...headers]?.filter(
            (e) => e.order > 0 && e.order < 100
          );
          const nOfLeftPinnedCols =
            [...headers]?.filter((e) => e.order < 0)?.length - 2;
          const movedColPrevOrder = draggedCol.order;
          const movedColNextOrder =
            rangeHeaders[Number(event?.toIndex) - nOfLeftPinnedCols].order;
          let toBeUpdatedFields: any[];
          if (movedColNextOrder > movedColPrevOrder) {
            // Dragged column moved down
            toBeUpdatedFields = rangeHeaders
              .filter(
                (e) =>
                  e.order > movedColPrevOrder && e.order <= movedColNextOrder
              )
              .map((col) => {
                const c = { ...col };
                c.order -= 1; // Shift order up
                return c;
              });
          } else if (movedColNextOrder < movedColPrevOrder) {
            // Dragged column moved up
            toBeUpdatedFields = rangeHeaders
              .filter(
                (e) =>
                  e.order >= movedColNextOrder && e.order < movedColPrevOrder
              )
              .map((col) => {
                const c = { ...col };
                c.order += 1; // Shift order down
                return c;
              });
          } else {
            // No movement, no updates needed
            toBeUpdatedFields = [];
          }
          const finalUpdatedFields = [
            ...toBeUpdatedFields,
            { ...draggedCol, order: movedColNextOrder },
          ];
          dispatch(updateFieldOrder(finalUpdatedFields)).then((resp) => {
            dispatch(updateColumnOrder(finalUpdatedFields));
          });
        }
      }
    },
    [headers]
  );

  const handleRowExpandCollapse = (toExpandId: string) => {
    const currentId = toExpandId;
    const isCurrentExpanded = expandedParent === currentId;
    const hasDifferentExpanded = expandedParent && expandedParent !== currentId;

    // Collapse if clicking the already expanded row
    if (isCurrentExpanded) {
      dispatch(setDocumentExpanded(""));
      dispatch(rowCollapseUpdate(currentId));
      return;
    }

    // Collapse previous expanded row if exists
    if (hasDifferentExpanded) {
      dispatch(rowCollapseUpdate(expandedParent));
    }

    // Expand current row
    const expandCurrentRow = () => {
      dispatch(setDocumentExpanded(currentId));
      dispatch(rowExpandUpdate(currentId)).then((res) => {
        if (res) {
          dispatch(
            setDocumentRowAsExpanded({
              clientId: selectedTab,
              id: currentId,
            })
          );
        }
      });
    };

    expandCurrentRow();
  };

  useEffect(() => {
    if (!isUploadPopupOpen) return;
    if (!gridRef.current || !selectedDocumentId) return;

    const api = gridRef.current.api;
    if (!api) return;

    const timeout = setTimeout(() => {
      const rowNode = api.getRowNode(selectedDocumentId);
      if (rowNode) {
        api.ensureNodeVisible(rowNode, 'bottom');
      }
    }, 100);

    return () => clearTimeout(timeout);
  }, [selectedDocumentId, isUploadPopupOpen]);

  return (
    <>
      <div
        className={classNames("ag-theme-alpine", {
          "pointer-events-none": selectedTabFilter?.name,
        })}
        style={customStyle}
      >
        <AgGridReact
          onColumnMoved={handleColumnDrag}
          ref={gridRef}
          components={components}
          columnDefs={transformedHeadersDef}
          rowData={transformedRowsData}
          getRowHeight={getRowHeight}
          headerHeight={
            2 * userTableFontSize * userLineHeight + userCellPadding * 1.25
          }
          rowSelection="single"
          getRowId={getRowId}
          animateRows={true}
          isRowSelectable={isRowSelectable}
          suppressCellFocus={true}
          onCellClicked={handleClick}
          isExternalFilterPresent={isExternalFilterPresent}
          doesExternalFilterPass={doesExternalFilterPass}
          overlayNoRowsTemplate="No Documents To Show"
          overlayLoadingTemplate="No Documents To Show"
          rowClassRules={{
            "row-child-lease": (params) =>
              !!params.data &&
              (params.data.parent !== "" ||
                (params.data.parent === "" &&
                  expandedParent === params.data.id)),
            "tr-on-hold": (params) =>
              params.data?.status === LEASE_STATUS.ON_HOLD,
            "tr-dead-deal": (params) =>
              params.data?.status === LEASE_STATUS.DEAD_DEAL,
            "tr-in-lease": (params) =>
              params.data?.status === LEASE_STATUS.IN_LEASE,
            "tr-lease-executed": (params) =>
              params.data?.status === LEASE_STATUS.EXECUTED_LEASE,
            "tr-active-lease": (params) =>
              !!params.data &&
              ![
                LEASE_STATUS.DEAD_DEAL,
                LEASE_STATUS.IN_LEASE,
                LEASE_STATUS.EXECUTED_LEASE,
              ].includes(params.data.status),
          }}
          onRowDataUpdated={() => {
            handleScrollSizeChange();
          }}
          onGridSizeChanged={() => {
            handleScrollSizeChange();
          }}
          onFirstDataRendered={() => {
            handleScrollSizeChange();
            findExpandedDocument();
          }}
          onColumnResized={handleColResize}
          rowDragManaged={false}
          rowDragEntireRow={true}
          suppressRowDrag={true}
          suppressMoveWhenRowDragging={true}
          suppressDragLeaveHidesColumns={true} //prevent hiding of columns on extreme drag
          onRowDragEnd={isReadOnly ? undefined : onDragEnd}
          onRowDragMove={isReadOnly ? undefined : onDragMove}
        ></AgGridReact>
      </div>
    </>
  );
}
export default Table;
